import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';

import { Dashboard as DashboardLayout } from 'layouts';

// Component styles
const styles = theme => ({
  root: {
    padding: theme.spacing(4)
  },
  item: {
    height: '100%'
  }
});

class Documents extends Component {
  render() {
    const { classes, title, children, menu, menuTitle, breadcrumbs } = this.props;

    return (
      <DashboardLayout
        specialMenu={menu}
        specialMenuTitle={menuTitle}
        title={title}
        breadcrumbs={breadcrumbs}
      >

        <div className={classes.root} style={this.props.style}>
          {children}
        </div>

      </DashboardLayout>
    );
  }
}

export default withStyles(styles)(Documents);
